import { useEffect, useState } from "react";
import logoImg from 'assets/images/ssgk/ssgk-logo.png';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
export const SchoolHeader = () => {
      const [isScrolled, setIsScrolled] = useState(false);
      const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (<header
        className={`fixed w-full z-50 transition-all duration-300 ${
          isScrolled
            ? "bg-white/95 backdrop-blur-sm shadow-md"
            : "bg-transparent"
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            <img src={logoImg} alt="School Logo" className="h-10" />
            <nav className="hidden md:flex items-center space-x-8">
              <a
                href="/home#events"
                className="black hover:-translate-y-1  font-medium transition-colors duration-200"
              >
                Events
              </a>
              <a
                href="/home#meetups"
                className="black hover:-translate-y-1 font-medium transition-colors duration-200"
              >
                Meetups
              </a>

              {/* <a
                href="/home#fundraising"
                className="black hover:-translate-y-1 font-medium  transition-colors duration-200"
              >
                Fundraising
              </a> */}
              <a
                href="/home#news"
                className="black hover:-translate-y-1  font-medium transition-colors duration-200"
              >
                News
              </a>
              <a
                href="/home#achievements"
                className="black hover:-translate-y-1 font-medium transition-colors duration-200"
              >
                Achievements
            </a>
            <div className="relative group">
              <button className="  black hover:-translate-y-1 font-small transition-colors duration-200">
                Explore
                <i className="fas fa-chevron-down ml-2"></i>
              </button>

              <div className="absolute left-0 hidden w-48 bg-white border border-gray-200 rounded-lg shadow-md group-hover:block">
                <a href="/user/alumini"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">
                  Find Alumini
                </a>
                <a href="/user/gatepass"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100  text-sm">
                  Request Visit pass
                </a>
                <a href="/user/icard"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100  text-sm">
                   Identity card
                </a>
                <a href="/user/myProfile"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100  text-sm">
                 My Profile
              </a>
                {localStorage?.getItem('user') ?
                  <a href="#" onClick={() => {
                    localStorage.clear()
                    getAuth().signOut()

                      .then(() => window.location.href = '/login')
                      .catch((error) => console.error('Logout error:', error));
                  }}
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">
                    Logout
                  </a> : null}
              </div>

          </div>
          </nav>


          <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-blue-800 focus:outline-none"
            >
              <i
                className={`fas ${
                  mobileMenuOpen ? "fa-times" : "fa-bars"
                } text-2xl`}
              ></i>
            </button>
          </div>
        </div>
        <div className={`md:hidden ${mobileMenuOpen ? "block" : "hidden"}`}>
          <div className="px-4 pt-2 pb-4 bg-white/95 backdrop-blur-sm space-y-2">
            <a
              href="/home#events"
              className="block px-4 py-2 text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
            >
              Events
            </a>
            <a
              href="/home#meetups"
              className="block px-4 py-2 text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
            >
              Meetups
            </a>

            {/* <a
              href="/home#fundraising"
              className="block px-4 py-2 text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
            >
              Fundraising
            </a> */}
            <a
              href="/home#news"
              className="block px-4 py-2 text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
            >
              News
            </a>
            <a
              href="/home#achievements"
              className="block px-4 py-2 text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
            >
              Achievements
          </a>
          <div className="relative group">
              <button className="block px-4 py-2 text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
              >
                Explore
                <i className="fas fa-chevron-down ml-2"></i>
              </button>

              <div className="absolute left-0 hidden w-48 bg-white border border-gray-200 rounded-lg shadow-md group-hover:block">
                <a href="/user/alumini"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">
                  Find Alumini
                </a>
                <a href="/user/gatepass"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100  text-sm">
                  Request Visit pass
                </a>
                <a href="/user/icard"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100  text-sm">
                   Identity card
              </a>
              <a href="/user/myProfile"
                  className="block px-4 py-2 text-gray-800 hover:bg-gray-100  text-sm">
                 My Profile
              </a>
              {localStorage?.getItem('user') ? <a href="#" onClick={() => {
                localStorage.clear()

                getAuth().signOut()
                  .then(() => window.location.href = '/login')
                  .catch((error) => console.error('Logout error:', error));
              }}
                className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">
                Logout
              </a> : null}
              </div>
          </div>
          </div>
        </div>
      </header >)}